'use strict'

/**
 *	takes care of session persistence and authorization routines
 */
angular.module('ATMGAuth', []).factory('Auth', AuthFactory)

AuthFactory.$inject = [
  '$localStorage',
  'ApiQuery',
  '$rootScope',
  'User',
  'Navigation',
  'Api.Store',
  'ApiCustomer',
  'FormService'
]

function AuthFactory(
  $storage,
  ApiQuery,
  $rootScope,
  User,
  Navigation,
  Store,
  Customer,
  FormService
) {
  var checked = false

  /**
   * 	checkLogin
   *	checks login credential against API
   */
  function login(email, p) {
    let payload = {
      email: email,
      password: p
    }
    return new Promise((resolve, reject) => {
      return ApiQuery('auth/login', payload, 'post')
        .then(response => {
          setToken(response.data.data.access_token)
          let user = response.data.data.user
          $storage.user = user
          if (user.customers.length > 1) {
            return selectCustomer(user)
              .then(cn =>
                ApiQuery('customer/select', { customer_number: cn }, 'POST')
              )
              .then(() => {
                Navigation.fetchMenus(true)
                Store.reset()
                setAuth(true)
                return resolve(true)
              })
              .catch(error => console.error(error))
          }

          Navigation.fetchMenus(true)
          Store.reset()
          setAuth(true)
          return resolve(true)
        })
        .catch(e => reject(e))
    })
  }

  /**
   *
   * 	logout
   *	tries to logout the user via API
   *  	resets local environment upon success
   */
  function logout() {
    return new Promise((resolve, reject) => {
      return ApiQuery('auth/logout', '', 'GET')
        .then(response => {
          revokeToken()
          $rootScope.$broadcast('auth.logout')
          setAuth(false)
          Navigation.fetchMenus(true)
          User.cleanup()
          Store.reset()
          resolve(true)
        })
        .catch(e => reject(e))
    })
  }

  /**
   *
   *	isLogged
   *	checks local storage delete the isLogged boolean and returns it
   *
   *	@return boolean
   */
  function isLogged() {
    return new Promise((resolve, reject) => {
      if (typeof $storage.token === 'undefined') {
        $storage.isLogged = false
        return reject()
      }
      if (!checked) {
        ApiQuery('auth/user', '', 'GET')
          .then(response => {
            checked = true
            setAuth(true)
            return resolve(true)
          })
          .catch(error => {
            return reject(error)
          })
      } else {
        return $storage.isLogged ? resolve(true) : reject()
      }
    })
  }

  function selectCustomer(user) {
    return new Promise((resolve, reject) => {
      $rootScope.$emit('modal.open', {
        title: 'Select Customer',
        template: 'select_customer',
        data: {
          options: user.customers,
          selected: user.current_customer.index
        },
        callback: function(customer_number) {
          return resolve(customer_number)
        }
      })
    })
  }

  /**
   *
   *  	setAuth
   *	private function
   *
   */
  function setAuth(value) {
    if (value) {
      $rootScope.$broadcast('auth.login')
      $storage.isLogged = true
      $rootScope.isLogged = true
    } else {
      $rootScope.isLogged = false
      delete $storage.isLogged
      delete $storage.token
    }
  }

  function setToken(token) {
    $storage.token = `Bearer ${token}`
  }

  function revokeToken() {
    delete $storage.token
  }

  /*
	*	passwordRequest
	*
	*/
  function passwordRequest(email) {
    return ApiQuery('auth/password/email', { email: email }, 'POST')
      .then(response => {
        return response.data.data.status
      })
      .catch(reason => {
        return reason
      })
  }

  /**
   *
   *
   *
   */
  function resetPassword(parms) {
    // by default we submit a request
    let endpoint = 'auth/password/email'
    // via POST
    let method = 'POST'

    // if token is there we wanna submit the reset
    // now we also include when the user is resettin
    if (!angular.isDefined(parms.email)) {
      parms.email = User.getUserData().userDetails.email
    }
    if (angular.isDefined(parms.token)) {
      endpoint = 'auth/password/reset'
    } else if (
      parms.password &&
      parms.password_confirmation &&
      parms.current_password
    ) {
      endpoint = 'auth/user'
      method = 'PUT'
    }

    return ApiQuery(endpoint, parms, method)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(response => {
        return Promise.reject(response.data)
      })
  }

  return {
    isLogged: isLogged,
    logout: logout,
    login: login,
    passwordRequest: passwordRequest,
    resetPassword: resetPassword,
    loading: function() {
      return loading
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/ATMGAuth/ATMGAuth.js